import { BrowserRouter } from "react-router-dom";
import Routes from "./Router/routes";
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
import 'bootstrap/dist/js/bootstrap.bundle.min';
// import "aos/dist/aos.css";
import 'bootstrap/dist/css/bootstrap.min.css';
 
import 'react-overlay-loader/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function App() {

  return (

    <BrowserRouter>
    <Routes />
    <ToastContainer />
  </BrowserRouter>
  );
}

export default App;
